import { useCallback } from 'react';

import { notifyBugsnag } from '../bugsnagClient';
import { nr } from '../newRelic';

type UnexpectedErrorReport = {
  error: string | Error;
  // eslint-disable-next-line yi/explicit-undefined-for-index-signature
  metadata?: { [key: string]: string | number | boolean };
};

export function useReportUnexpectedError() {
  const report = useCallback(({ error, metadata }: UnexpectedErrorReport) => {
    notifyBugsnag(error, metadata);
    nr.noticeError(error, metadata);
  }, []);

  return report;
}
